import AdvancedController from "./advanced-controller"
import { slideIn, slideOut } from "../animations/animation-slide";

export default class AccordionItemController extends AdvancedController {

  static targets = ['body'];

  static values = {
    isOpen: Boolean
  }

  connect() {
    super.connect(...arguments);
    const accordionEl = this.element.closest('.block__accordion')
    this._accordionController = accordionEl['accordion']
    this._accordionController.messageItemConnected(this)
  }

  onToggle() {
    this.isOpenValue = !this.isOpenValue
    this._handleState();
  }

  messageClose() {
    this.isOpenValue = false
    this._handleState();
  }

  messageOpen() {
    this.isOpenValue = true
    this._handleState();
  }

  _handleState() {
    if (this.isOpenValue) {
      slideIn(this.bodyTarget)
      this._accordionController.messageAddActive(this)
    } else {
      slideOut(this.bodyTarget)
    }

  }

}
